import { TABS, type TabId } from '../types';

type Props = {
  active: TabId;
  onChange: (id: TabId) => void;
};

export default function Tabs({ active, onChange }: Props) {
  return (
    <nav className="tab-nav">
      {TABS.map((t) => (
        <button
          key={t.id}
          className={`tab-btn ${active === t.id ? 'is-active' : ''}`}
          onClick={() => onChange(t.id)}
          disabled={!t.ready}
          title={t.ready ? '' : 'Not yet ported'}
        >
          {t.label}
          {!t.ready && <span className="tab-stub-badge">soon</span>}
        </button>
      ))}
    </nav>
  );
}
